import { h } from 'preact';

export const Checkmark = (): h.JSX.Element => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      clip-rule="evenodd"
      d="M12.6402 4.2318C13.0645 4.58537 13.1218 5.21593 12.7682 5.64021L7.76822 11.6402C7.58835 11.856 7.32599 11.9863 7.04531 11.999C6.76464 12.0117 6.49156 11.9058 6.29289 11.7071L4.29289 9.70713C3.90237 9.31661 3.90237 8.68344 4.29289 8.29292C4.68342 7.90239 5.31658 7.90239 5.70711 8.29292L6.9328 9.51861L11.2318 4.35984C11.5853 3.93556 12.2159 3.87824 12.6402 4.2318Z"
      fill="white"
      fill-rule="evenodd"
    />
  </svg>
);
